import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Search } from "lucide-react";
import { trackEvent } from "@/lib/trackEvent";

/** Bare AI Coin Reviewer entry point — one input, no marketing graphics.
 *  `bare` drops the section/container wrapper so it can sit inside a card. */
export function ReviewerSearchBar({ bare = false }: { bare?: boolean }) {
  const [value, setValue] = useState("");
  const navigate = useNavigate();

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    const q = value.trim();
    if (!q) return;
    trackEvent("coin_review_started", { source: "home_search_bar" });
    navigate(`/coin-reviewer?symbol=${encodeURIComponent(q.toUpperCase())}`);
  };

  const form = (
    <form onSubmit={submit} className="flex gap-2 items-center">
      <label htmlFor="home-reviewer-search" className="sr-only">
        Review any coin
      </label>
      <div className="relative flex-1">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
        <Input
          id="home-reviewer-search"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder="Review any coin — ticker or name (e.g. BTC, SOL, FARTCOIN)"
          className="pl-9 h-11 font-mono text-sm bg-background/80"
          autoComplete="off"
        />
      </div>
      <Button type="submit" className="h-11 px-5 font-semibold">
        Review
      </Button>
    </form>
  );

  if (bare) return form;

  return (
    <section aria-label="AI Coin Reviewer" className="container mx-auto px-4 py-3">
      {form}
    </section>
  );
}
